import {FormControl, FormHelperText, FormLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles} from "@material-ui/core";
import Tr from "translations/Translations";
import Button from "components/Button";
import AddIcon from "@material-ui/icons/Add";
import React, {useState} from "react";
import getObjectValue from "libs/getObjectValue";
import AuditTaskAllowedObjectRow from "./AuditTaskAllowedObjectRow";
import {VALUES} from "../constants/AuditTaskAllowedObjectType";
import AuditTaskAllowedObjectPopup from "./AuditTaskAllowedObjectPopup";
import GridBlock from "../../../../components/GridBlock";

const style = theme => ({
    error: {
        marginTop: 0,
        marginBottom: theme.spacing(1),
    },
    cell: {
        padding: theme.spacing(1),
    },
    type: {
        width: 100
    },
    number: {
        width: 250
    },
    name: {
        width: 600,
        wordBreak: 'normal'
    },
    button: {
        width: 50,
        padding: '0 !important'
    },
    buttonNew: {
        width: 250,
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1)
    },
    icon: {
        marginRight: theme.spacing(1)
    },
    buttons: {
        paddingBottom: theme.spacing(4)
    }
})

function AuditTaskAllowedObjectTable({
    formikProps,
    required,
    editable,
    className,
    classes
}) {
    const id = 'allowedObjects';
    const idCount = id + 'Count';
    const errorValue = getObjectValue(idCount, formikProps.errors, '');
    const touched = getObjectValue(idCount, formikProps.touched, false);
    const isError = !!errorValue && touched?.count;
    const helperText = isError ? errorValue : '';
    const _label = Tr('audit_task_allowed_objects') + (required ? '*' : '');

    const allowedObjects = getObjectValue(id, formikProps.values, []);
    const allowedObjectsCount = getObjectValue(idCount, formikProps.values, []);
    const taskId = getObjectValue('identity', formikProps.values, null);

    const [allowedObjectPopup, setAllowedObjectPopup] = useState(false);
    const [allowedObjectType, setAllowedObjectType] = useState('');

    const pickAllowedObject = (pickedAllowedObjects) => {
        pickedAllowedObjects.forEach(ao => {
            allowedObjects.push({
                identity: -1,
                objectIdentity: ao.objectIdentity,
                objectType: ao.objectType,
                objectNumber: ao.objectNumber,
                objectName: ao.objectName,
                objectStatus: ao.objectStatus
            })
        });
        allowedObjectsCount.count = allowedObjects.length;

        formikProps.setFieldTouched(`${idCount}.count`, true);
        setAllowedObjectPopup(false);
    }

    const deleteAllowedObject = (index) => {
        allowedObjects.splice(index, 1);
        allowedObjectsCount.count = allowedObjects.length;
        formikProps.setFieldTouched(`${idCount}.count`, true);
    }

    return (
        <FormControl
            error={isError}
            className={className}
        >
            <FormLabel>{_label}</FormLabel>
            <TableContainer>
                <Table >
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.type}>{Tr("audit_task_allowed_object_type")}</TableCell>
                            <TableCell className={classes.number}>{Tr("number_of_processing")}</TableCell>
                            <TableCell className={classes.name}>{Tr("name")}</TableCell>
                            <TableCell className={classes.type}>{Tr("status")}</TableCell>
                            <TableCell className={classes.button}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!allowedObjects.length && allowedObjects.map((ao, index) =>
                            <AuditTaskAllowedObjectRow
                                key={`ao${index}`}
                                id={`allowedObjects`}
                                index={index}
                                formikProps={formikProps}
                                editable={editable}
                                taskId={taskId}
                                deleteAllowedObject={deleteAllowedObject}
                            />
                        )}
                        {!allowedObjects.length && <TableRow>
                            <TableCell colSpan="5">{Tr('audit_task_allowed_object_empty')}</TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <FormHelperText className={classes.error}>{helperText}</FormHelperText>
            {editable && <GridBlock
                alignItems='center'
                className={classes.buttons}
            >
                <Button
                    className={classes.buttonNew}
                    color={'primary'}
                    variant={undefined}
                    onClick={() => {
                        setAllowedObjectType(VALUES.PURCHASE_REQUEST);
                        setAllowedObjectPopup(true);
                    }}

                >
                    <AddIcon className={classes.icon}/>
                    {Tr('audit_task_allowed_object_choose_purchase_request')}
                </Button>
                <Button
                    className={classes.buttonNew}
                    color={'primary'}
                    variant={undefined}
                    onClick={() => {
                        setAllowedObjectType(VALUES.DEMAND);
                        setAllowedObjectPopup(true);
                    }}

                >
                    <AddIcon className={classes.icon}/>
                    {Tr('audit_task_allowed_object_choose_demand')}
                </Button>
                <Button
                    className={classes.buttonNew}
                    color={'primary'}
                    variant={undefined}
                    onClick={() => {
                        setAllowedObjectType(VALUES.AGREEMENT);
                        setAllowedObjectPopup(true);
                    }}

                >
                    <AddIcon className={classes.icon}/>
                    {Tr('audit_task_allowed_object_choose_agreement')}
                </Button>
            </GridBlock>}
            {editable && allowedObjectPopup && <AuditTaskAllowedObjectPopup
                taskId={taskId}
                excludeObjectIds={allowedObjects.filter(ao => ao.objectType === allowedObjectType).map(ao => ao.objectIdentity)}
                open={true}
                objectType={allowedObjectType}
                onCancel={() => setAllowedObjectPopup(false)}
                onConfirm={(ao) => pickAllowedObject(ao)}
            />}
        </FormControl>
    )
}

export default withStyles(style)(AuditTaskAllowedObjectTable);